import { Button } from "antd";
import cx from "classnames";
import { useRouter } from "next/router";
import React from "react";
import { isMobile } from "react-device-detect";

import { ReadMoreSpan } from "@/components/ModalReadMore";
import SwiperMC from "@/components/SwiperMC";
import CardUserProfile from "@/components/v2/CardUserProfile";
import ErrorEmptyV2 from "@/components/v2/ErrorEmpty";
import { Endorsement } from "@/graphql/graphql";

import { useGetUserProfile } from "@/hooks/useUsers";
import useAuthStore from "@/store/useAuthStore";
import { PAGE_URL } from "@/utils/constants";

export default function EndorsementWidget() {
  const authUser = useAuthStore.useUser();
  const userId = authUser?.profile?.id;
  const { data, isLoading } = useGetUserProfile(userId);
  const endorsement: Endorsement[] = (
    (data?.endorsements as Endorsement[]) || []
  ).filter(({ status }) => status === "APPROVED");

  const router = useRouter();

  const onClickViewMore = () => {
    router.push({
      pathname: PAGE_URL.profile,
      query: { open: "endorsement" },
    });
  };

  return (
    <section className="bg-card px-4 py-8 lg:w-full flex flex-col relative">
      {!isLoading && endorsement.length > 0 && (
        // <div className="top-0 right-0 flex justify-end bg-card">
        <div className="top-4 right-6 flex justify-end bg-card absolute z-10">
          <Button type="text" style={{ padding: 0 }} onClick={onClickViewMore}>
            <span className="text-yellow">View More</span>
          </Button>
        </div>
      )}
      {endorsement.length > 0 ? (
        <SwiperMC
          wrapperClassName="mt-7"
          loading={isLoading}
          alwaysShowNavigation
          data={endorsement}
          render={(payload, i) => (
            <EndorsementDetail endorsement={payload} key={i} />
          )}
          props={{
            loop: true,
          }}
        />
      ) : (
        <ErrorEmptyV2 isFullWidth which="dashboard-endorsement" />
      )}
    </section>
  );
}

interface IEndorsementDetailProps {
  endorsement: Endorsement;
}

const paragraphStyle: React.CSSProperties = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  lineHeight: "1.5em",
  minHeight: "3em",
};

function EndorsementDetail({ endorsement }: IEndorsementDetailProps) {
  const { createdBy, description } = endorsement;

  return (
    <div className="w-full text-white bg-card">
      <div className="lg:mx-4 lg:mb-4">
        <div className={cx("lg:px-14 gap-x-4 lg:flex")}>
          <div className="flex justify-center lg:justify-start">
            <CardUserProfile
              avatarOnly
              item={createdBy as any}
              avatarSize="sm"
              points={createdBy.points ?? undefined}
              findCG
            />
          </div>

          <div className={cx({ "text-center lg:text-left mt-4": isMobile })}>
            <b>{`${createdBy.firstName} ${createdBy.lastName}`}</b>
            {/* <Tooltip
              title={description}
              placement="top"
              overlayStyle={{ maxWidth: "800px" }}
            > */}
            <p style={paragraphStyle}>
              <ReadMoreSpan
                content={description}
                maxTruncate={{
                  sm: 80,
                  lg: 320,
                }}
                title={`${createdBy.firstName} ${createdBy.lastName}`}
              />
            </p>
            {/* </Tooltip> */}
          </div>
        </div>
      </div>
    </div>
  );
}
